var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.76cdeb9197d5a6d4bd86fe2caf7cfc38.svg#r';
                    var viewUrl = 'sprites.76cdeb9197d5a6d4bd86fe2caf7cfc38.svg#view-r';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 10 11',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };